import {checkmarkIcon, closeIcon, moreIcon, creditingRequestedIcon} from '@ace-de/ui-components';
import {mafInvoiceSubmissionStatuses} from '@ace-de/eua-entity-types';

export const invoiceSubmissionStatusesIcons = {
    [mafInvoiceSubmissionStatuses.CREDITING_REQUESTED]: creditingRequestedIcon,
    [mafInvoiceSubmissionStatuses.PROCESSING]: moreIcon,
    [mafInvoiceSubmissionStatuses.PARTIAL_REFUND]: checkmarkIcon,
    [mafInvoiceSubmissionStatuses.TOTAL_REFUND]: checkmarkIcon,
    [mafInvoiceSubmissionStatuses.DENIED]: closeIcon,
};

export const invoiceSubmissionStatusesTexts = {
    [mafInvoiceSubmissionStatuses.CREDITING_REQUESTED]: 'Rechnung eingereicht',
    [mafInvoiceSubmissionStatuses.PROCESSING]: 'In Bearbeitung',
    [mafInvoiceSubmissionStatuses.PARTIAL_REFUND]: 'Teilerstattung',
    [mafInvoiceSubmissionStatuses.TOTAL_REFUND]: 'Komplette Erstattung',
    [mafInvoiceSubmissionStatuses.DENIED]: 'Abgelehnt',
};
